import { render, staticRenderFns } from "./campaign-parameters.vue?vue&type=template&id=15693709&"
import script from "./campaign-parameters.vue?vue&type=script&lang=js&"
export * from "./campaign-parameters.vue?vue&type=script&lang=js&"
import style0 from "./campaign-parameters.vue?vue&type=style&index=0&id=15693709&prod&lang=css&"
import style1 from "./campaign-parameters.vue?vue&type=style&index=1&id=15693709&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports